<script setup lang="ts">
import {
	mdiAlertOutline,
	mdiFileDocumentOutline,
	mdiTextBoxMultipleOutline,
	mdiViewDashboardOutline,
} from "@mdi/js";
import { Features } from "@soft-db/monitoring-api-client";
import { Icon } from "@soft-db/ui";
import AppToggle from "../common/AppToggle.vue";
import { icMonitorHeartOutline } from "../icons";

const model = defineModel<boolean>();
const { feature } = defineProps<{
	feature: keyof Features;
	showWarning?: boolean;
}>();

const { t } = useI18n();

const icon = computed(() => {
	switch (feature) {
		case "dashboard":
			return mdiViewDashboardOutline;
		case "integrity":
			return icMonitorHeartOutline;
		case "report":
			return mdiTextBoxMultipleOutline;
		case "audit":
			return mdiFileDocumentOutline;
	}
});

const label = computed(() => {
	switch (feature) {
		case "dashboard":
			return t("common.dashboard");
		case "integrity":
			return t("integrity-settings.integrity");
		case "report":
			return t("object.report");
		case "audit":
			return t("common.audit");
	}
});
</script>

<template>
	<div>
		<AppToggle v-model="model" :icon="icon" :label="label" />
		<span v-if="showWarning" class="text-warning text-center text-sm font-semibold">
			<Icon class="inline" size="sm" :d="mdiAlertOutline" />

			{{ t("users.featureWarning") }}
		</span>
	</div>
</template>
